import {GlobalContext, ReducerActionType} from "../../../GlobalReducer";
import {ReducerStateInterface} from "../../../interfaces/core/ReducerStateInterface";
import TableOfSizesPopup from "./TableOfSizesPopup";

import {useState, useEffect, useContext} from "react";
import {useForm} from "react-hook-form";
import {sendSubscribeMail} from "../../../api/landing";

export enum QuestionStatus {
    QuestionDefault = "QuestionDefault",
    QuestionSent = "QuestionSent",
}

export default function QuestionPopup() {
    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);

    const [questionForm, setQuestionForm] = useState<QuestionStatus>(QuestionStatus.QuestionDefault);

    const {register, handleSubmit, reset, formState} = useForm();

    useEffect(() => {
        if (formState.isSubmitSuccessful) {
            reset({name: "", phone: "", email: "", order_number: "", question: ""});
        }
    }, [formState, reset]);

    let formSubmit = async (data: any) => {
        // console.log('data', data.name, data.phone,  data.email, data.order_number, data.question)
        try {
            // const res = await sendSubscribeMail({
            //     name: data.name,
            //     phone: data.phone,
            //     email: data.email,
            //     order_number: data.order_number,
            //     question: data.question,
            // });
            setQuestionForm(QuestionStatus.QuestionSent);
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <>
            <TableOfSizesPopup>
                <div className="modal-body">
                    {questionForm === QuestionStatus.QuestionDefault ? (
                        <div className="modal-form">
                            <h4 className="modal-form__title f-exp">Задать вопрос</h4>
                            <form onSubmit={handleSubmit(formSubmit)}>
                                <div className="form-group">
                                    <label className="form-label">Имя</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Имя"
                                        id="name"
                                        {...register("name", {required: false})}
                                    />
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Телефон</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="+7"
                                        id="phone"
                                        {...register("phone", {required: false})}
                                    />
                                </div>
                                <div className="form-group">
                                    <label className="form-label">E-mail</label>
                                    <input
                                        id="email"
                                        type="email"
                                        placeholder="E-mail"
                                        className="form-control"
                                        {...register("email", {
                                            required: "Email is required",
                                            pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                                message: "Email заполнен неправильно",
                                            },
                                        })}
                                    />
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Номер заказа</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Введите номер заказа"
                                        id="order_number"
                                        {...register("order_number", {required: false})}
                                    />
                                </div>
                                <div className="form-group">
                                    <label className="form-label">Ваш вопрос</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="Вопрос"
                                        id="question"
                                        {...register("question", {required: false})}
                                    />
                                </div>
                                <div className="form-btns">
                                    <button className="btn btn-secondary">Отправить</button>
                                </div>
                                <div className="form-foot">
                                    <p>
                                        Нажимая кнопку “Отправить”, Вы соглашаетесь с{" "}
                                        <a href="/landing/26" target="blank">
                                            Политикой конфиденциальности
                                        </a>{" "}
                                        и
                                        <a href="/landing/27" target="blank">
                                            Политикой обработки cookies
                                        </a>
                                    </p>
                                </div>
                            </form>
                        </div>
                    ) : (
                        <>
                            <div className="modal-form">
                                <h4 className="modal-form__title f-exp">Ваш вопрос отправлен</h4>
                                <form action="">
                                    <div className="form-text">
                                        <p>
                                            Мы пришлём Вам ответ в течение 3 рабочих дней
                                            <br /> на указанный адрес электронной почты.
                                        </p>
                                    </div>
                                    <div className="form-btns">
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => {
                                                dispatch({type: ReducerActionType.CLOSE_ALL_POPUP});
                                            }}
                                        >
                                            Ок
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </>
                    )}
                </div>
            </TableOfSizesPopup>
        </>
    );
}
